import {Component, Inject, LOCALE_ID, OnDestroy, OnInit} from '@angular/core';
import {Dotaznik} from '../model/dotaznik';
import {Subscription} from 'rxjs';
import {AppService} from '../app.service';

@Component({
  selector: 'app-dotazniky',
  templateUrl: './dotazniky.component.html',
  styleUrls: ['./dotazniky.component.css']
})
export class DotaznikyComponent implements OnInit, OnDestroy {

  data: Dotaznik[];

  show = false;
  loading = true;
  expanded = false;

  dotaznikyDataSubscription: Subscription;
  onDotaznikyClickSubscription: Subscription;

  constructor(
      private appService: AppService,
      @Inject(LOCALE_ID) private locale: string
  ) { }

  ngOnInit() {
    this.dotaznikyDataSubscription =
      this.appService.dotaznikyData
      .subscribe((data: Dotaznik[]) => {
        this.data = data;
        this.loading = false;
        this.expanded = data.find($i => $i.rozpracovany === false) !== undefined;
      });

    this.appService.fetchDotazniky();

    this.onDotaznikyClickSubscription =
        this.appService.onDotaznikyClickSubject.subscribe(
            () => {
              this.show = !this.show;
            }
        );
  }

  ngOnDestroy(): void {
    this.dotaznikyDataSubscription.unsubscribe();
    this.onDotaznikyClickSubscription.unsubscribe();
  }

  openDotaznik(d: Dotaznik) {
    if (d.ukonceny) {
      return;
    }
    window.location.href = '/ais/apps/dotazniky/app/index.html#!/dotaznik/' + d.idAktivacia + '?lng=' + this.locale.toUpperCase();
  }

  getNazov(d: Dotaznik) {
    return d.nazov + (d.poznamka ? (' - ' + d.poznamka) : '');
  }

}
